import { render, staticRenderFns } from "./podium-row.vue?vue&type=template&id=55b72ab9&scoped=true&"
import script from "./podium-row.vue?vue&type=script&lang=js&"
export * from "./podium-row.vue?vue&type=script&lang=js&"
import style0 from "./podium-row.vue?vue&type=style&index=0&id=55b72ab9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b72ab9",
  null
  
)

export default component.exports